module.exports = __webpack_public_path__ + "static/media/Ventilator_Tropfen.b4f8e8f0.svg";